import { ReactNode } from "react";
import "./Button.scss";
import { createSpreadableBem } from "/Helpers/createBem";

export interface ButtonProps {
  style:
    | "primary"
    | "secondary"
    | "insight-secondary"
    | "disabled"
    | "disabled-secondary"
    | "tertiary";
  size?: "s" | "m" | "l";
  label: string;
  onClick?: () => void;
  href?: string;
  target?: string;
  disabled?: boolean;
  iconAfter?: ReactNode;
  iconBefore?: ReactNode;
  tabIndex?: number;
}

const Button = ({
  style,
  size = "m",
  label,
  onClick,
  href,
  target,
  disabled,
  iconAfter,
  iconBefore,
  tabIndex,
}: ButtonProps) => {
  const bem = createSpreadableBem("button-norad");
  return (
    <>
      {onClick && !href && (
        <button
          onClick={onClick}
          {...bem("", `--${style}`, `--${size}`)}
          disabled={disabled}
          tabIndex={tabIndex}
        >
          {iconBefore && <span {...bem("__icon", "--before")}>{iconBefore}</span>}
          <span {...bem("__label")}>
            <span {...bem("__label-text")}>{label}</span>
          </span>
          {iconAfter && <span {...bem("__icon", "--after")}>{iconAfter}</span>}
        </button>
      )}
      {!onClick && href && (
        <a
          href={href}
          target={target}
          tabIndex={tabIndex}
          {...bem("", `--${style}`, `--${size}`)}
        >
          {iconBefore && <span {...bem("__icon", "--before")}>{iconBefore}</span>}
          <span {...bem("__label")}>
            <span {...bem("__label-text")}>{label}</span>
          </span>
          {iconAfter && <span {...bem("__icon", "--after")}>{iconAfter}</span>}
        </a>
      )}
      {!onClick && !href && (
        <div {...bem("", `--${style}`, `--${size}`)}>
          <span {...bem("__label")}>
            <span {...bem("__label-text")}>{label}</span>
          </span>
        </div>
      )}
    </>
  );
};
export default Button;
